<template>
  <div id="app" class="wrapper">
    <router-view></router-view>
  </div>
</template>

<script>
  export default {
    name: 'App',
  };
</script>

<style lang="scss">
  @import 'assets/scss/style';
</style>



// WEBPACK FOOTER //
// src/App.vue